export const UNIT_MAP: Record<string, string> = {
    'ft3/m': 'ft3m',
    'L/m': 'Lmin',
    'L/s': 'Lsec',
    'kg/cm2': 'kgcm2',
    ft: 'ftH2O',
    m: 'mH2O',
};
